import { useState, useCallback } from "react";
import { toast } from "react-toastify";

const useApi = (initialApiState = { data: null, loading: false }) => {
    const [apiState, setApiState] = useState(initialApiState);

    const callApi = useCallback((request) => {
        setApiState((prevState) => ({ ...prevState, loading: true }));

        const isFormData = request.body instanceof FormData;

        // Get the Google ID token from localStorage
        const tokenId = localStorage.getItem("userToken");

        return new Promise(async (resolve, reject) => {
            try {
                const response = await fetch(request.url, {
                    method: request.method || "GET",
                    headers: {
                        // Include the Authorization header if the token exists
                        ...(tokenId && { Authorization: `Bearer ${tokenId}` }),
                        ...(!isFormData && {
                            "Content-Type": "application/json",
                        }),
                        ...request.headers,
                    },
                    body:
                        request.method !== "GET" &&
                        request.method !== "DELETE" &&
                        request.body
                            ? isFormData
                                ? request.body
                                : JSON.stringify(request.body)
                            : null,
                });
                if (response.ok) {
                    let data;
                    // Handle no content
                    if (response.status === 204) {
                        data = null; // Or some default state appropriate for your application
                    } else {
                        // Use responseType to determine how to parse the response
                        data =
                            request.responseType === "blob"
                                ? await response.blob()
                                : await response.json();
                    }
                    setApiState({ data, loading: false });
                    resolve(data);
                } else {
                    let error;
                    try {
                        error = await response.json();
                    } catch {
                        error = { message: "An unknown error occurred" };
                    }
                    toast.error(error.message || "An error occurred");
                    setApiState((prevState) => ({
                        ...prevState,
                        loading: false,
                    }));
                    reject(error);
                }
            } catch (error) {
                console.error("API call failed:", error);
                toast.error("There was a problem with the API call.");
                setApiState((prevState) => ({ ...prevState, loading: false }));
                reject(error);
            }
        });
    }, []);

    return [apiState, callApi];
};

export default useApi;
